import { Pipe, PipeTransform } from '@angular/core';
import { Model } from '../../models';

@Pipe({
  name: 'modelFilter'
})

export class ModelFilterPipe implements PipeTransform {
  transform(items: Model[], type: string): any[] {
    const result = items;
    if (!items) {
      return [];
    }
    if (type === '' || type === undefined) {
      return result;
    } else {
      return items.filter(item => item.questionnaireType === parseInt(type) || item.ident === '0');
    }
  }
}
